import { CloseS12 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './TagNew.css';

interface ITagNew {
  onDeleteClick(): void;
}

export const TagNew: React.FC<ITagNew> = ({ children, onDeleteClick }) => {
  return (
    <div className={styles['container']}>
      {children}
      <button className={styles['button']} onClick={onDeleteClick}>
        <CloseS12 color="current_color" />
      </button>
    </div>
  );
};
